<template>
  <div style="cursor: pointer;width: fit-content">
    <div v-on:click="getFile()" v-if="this.mood === 'normal'">
      {{ label || name }}
    </div>
    <span
      v-on:click="getFile()" v-if="this.mood === 'compact'"
      style="cursor:pointer;width: fit-content;"
    >
       <feather-icon icon="FileTextIcon"/>
    </span>
  </div>
</template>

<script>

import { mapActions } from 'vuex';

export default {
  components: {},
  mixins: [],
  props: {
    path: {
      type: String,
      required: true,
      default: () => ''
    },
    name: {
      type: [String],
      required: true,
      default: () => ''
    },
    force: {
      type: String,
      required: false,
      default: ''
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    mood: {
      type: String,
      required: false,
      default: 'normal'
    },
    versionId: {
      type: String,
      required: false,
      default: ''
    }
  },
  watch: {},
  computed: {},
  methods: {
    ...mapActions('Dnts', [
      'downloadPrivateFile'
    ]),
    getFile() {
      const payload = { path: this.path, nombre: this.name, descargable: this.force };
      if (this.versionId) {
        payload.versionId = this.versionId;
      }
      this.downloadPrivateFile(payload);
    }
  }
};
</script>

<style lang="css" scoped>

.margin-top {
  margin-top: 20px;
}

.margin-right {
  margin-right: 10px;
}

.wrap-option {
  background: #f8f8f8;
  margin-bottom: 6px;
}

.input-option {
  color: inherit;
  margin-top: 4px;
  width: 100%;
  background: transparent;
}

.input-blocked {
  color: inherit;
  border: none !important;
  padding: 4px 4px 6px 4px;
  border-radius: 5px;
}

.input-edit {
  color: inherit;
  border: 1px solid #66258324;
  padding: 4px 4px 6px 4px;
  border-radius: 5px;
}

.selected {
  background: #cfe7f3;
}

</style>
